var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_c('GenericError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }